import { useContext } from 'react';
import type { OnboardingChecklistStep } from '../shared/types';
import { DEFAULT_SETUP_STEPS } from './constants';
import { SetupStepsContext } from './setup-steps-context';

/** Platform's setup steps from `withPageProviders`, falling back to the agnostic defaults. */
export function useSetupSteps(): OnboardingChecklistStep[] {
  return useContext(SetupStepsContext) ?? DEFAULT_SETUP_STEPS;
}
